// Утилиты для обработки и отображения ошибок

/**
 * Перенаправляет пользователя на страницу ошибки в зависимости от типа ошибки
 * @param {object} error - объект ошибки (обычно из axios или другой библиотеки)
 * @param {object} navigate - функция навигации из react-router (useNavigate)
 */
export const handleError = (error, navigate) => {
  console.error('ErrorHandler: Error occurred:', error);
  
  // Store error details in sessionStorage
  const storeErrorInSession = (errorData) => {
    sessionStorage.setItem('lastApiError', JSON.stringify(errorData));
  };
  
  // Если нет объекта ошибки
  if (!error) {
    storeErrorInSession({
      status: 500,
      message: 'Unknown error occurred',
      timestamp: new Date().toISOString()
    });
    navigate('/error/500');
    return;
  }
  
  // Проверяем, есть ли у ошибки ответ от сервера (axios error)
  if (error.response) {
    const { status } = error.response;
    
    // Store error details
    storeErrorInSession({
      status,
      message: error.response.data?.error || error.message,
      timestamp: new Date().toISOString()
    });
    
    switch (status) {
      case 401:
        // Неавторизованный доступ, перенаправляем на страницу логина
        navigate('/login');
        break;
      case 403:
        // Доступ запрещен
        navigate('/error/403');
        break;
      case 404:
        // Ресурс не найден
        navigate('/error/404');
        break;
      case 500:
      case 502:
      case 503:
      case 504:
        // Серверные ошибки
        navigate('/error/500');
        break;
      default:
        // Другие ошибки HTTP
        navigate(`/error/${status}`);
        break;
    }
  } else if (error.request) {
    // Запрос был сделан, но ответ не получен (например, сеть недоступна)
    storeErrorInSession({
      status: 'network-error',
      message: 'Network error - unable to connect to the server',
      timestamp: new Date().toISOString()
    });
    navigate('/maintenance');
  } else {
    // Что-то пошло не так при настройке запроса
    storeErrorInSession({
      status: 500,
      message: error.message || 'An unknown error occurred',
      timestamp: new Date().toISOString()
    });
    navigate('/error/500');
  }
};

/**
 * Проверяет ответ API на наличие ошибок и обрабатывает их
 * @param {function} apiCall - асинхронная функция, выполняющая запрос к API
 * @param {object} navigate - функция навигации из react-router
 * @param {function} onSuccess - коллбэк для успешного выполнения запроса
 * @param {function} onError - дополнительный обработчик ошибок (опционально)
 */
export const apiErrorHandler = async (apiCall, navigate, onSuccess, onError = null) => {
  try {
    const response = await apiCall();
    if (onSuccess) {
      onSuccess(response);
    }
    return response;
  } catch (error) {
    if (onError) {
      onError(error);
    }
    handleError(error, navigate);
    return null;
  }
};

const errorHandler = {
  handleError,
  apiErrorHandler
};
export default errorHandler; 